import { combineReducers } from "redux";
import mfa from "./mfa";
import token from "./token";
import user from "./user";
export default combineReducers({
    mfa,
    token,
    user,
});
